export default {
  state: {
    ActiveTab: 1
  },
  getters: {
    getActiveTab: state => state.ActiveTab
  },
  mutations: {
    SetActiveTab (state, val) {
      state.ActiveTab = val
    }
  }
}
